import axios from 'axios';

const zeroTrustBaseUrl = '/rest-api/feature-toggle/v1';
const fallbackBaseUrl = '/api/feature-toggle-service/v1';

const featureFlagService = {
  HasItemInStrategy: (
    featureName,
    strategyName,
    parameterName,
    parameterValue,
    { ssoToken, isZeroTrust },
  ) => {
    const baseUrl = isZeroTrust ? zeroTrustBaseUrl : fallbackBaseUrl;

    const params = new URLSearchParams([
      ['parameter_name', parameterName],
      ['parameter_value', parameterValue],
    ]);

    return axios.get(
      `${baseUrl}/feature/${featureName}/strategy/${strategyName}?${params.toString()}`,
      {
        headers: isZeroTrust ? { Authorization: `Bearer ${ssoToken}` } : null,
      },
    );
  },
};

export { featureFlagService };
